<template>
    <div>
        <div 
            class="d-flex align-items-baseline w-fit-content gap-2 btn btn-xs text-white bg-soft-light bg-dark-hover border border-secondary-hover mt-5 fs-6" 
            @click="toggleModal"
        >
            {{ $translate('report_bug_button_text', 'Rapportera ett fel') }}
            <i class="bi bi-exclamation-triangle text-danger fs-5" />
        </div>
        <ReportBugModal v-model="show" />
    </div>
</template>

<script>
import ReportBugModal from './ReportBugModal.vue';
export default {
    components: {
        ReportBugModal
    },
    data() {
        return {
            show: false
        };
    },
    methods: {
        toggleModal() {
            this.show = !this.show;
        }
    }
};
</script>